import React from 'react';
import { Button } from '../../../ui/Button';
import { Copy } from 'lucide-react';
import { FormRow } from '../components/FormRow';
import { FormField } from '../components/FormField';
import { usePropertyFormContext } from '../contexts/PropertyFormContext';
import { PropertyTypeSelector } from '../components/PropertyTypeSelector';
import { OwnerInfo } from './GeneralInfo/OwnerInfo';
import { PropertyInfo } from './GeneralInfo/PropertyInfo';
import { PricingInfo } from './GeneralInfo/PricingInfo';

interface GeneralInfoProps {
  onNext: () => void;
}

export const GeneralInfo: React.FC<GeneralInfoProps> = ({ onNext }) => {
  const { formData, handleInputChange, handleCopyAddress } = usePropertyFormContext();

  const handleNext = () => {
    if (!formData.propertyType) {
      alert('Veuillez sélectionner un type de bien');
      return;
    }
    onNext();
  };

  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 sm:divide-x-2 divide-gray-200 dark:divide-gray-700 gap-6 sm:gap-8">
        {/* Colonne gauche - Informations du propriétaire */}
        <div className="space-y-6 sm:pr-8">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 sm:h-6 sm:w-6 items-center justify-center rounded-full bg-primary-500 text-base sm:text-sm text-white">1</span>
            <h3 className="text-xl sm:text-lg font-medium text-gray-900 dark:text-white">
              Informations du propriétaire
            </h3>
          </div>
          <OwnerInfo formData={formData} handleInputChange={handleInputChange} />
        </div>

        {/* Colonne droite - Informations du bien */}
        <div className="space-y-6 sm:pl-8">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 sm:h-6 sm:w-6 items-center justify-center rounded-full bg-primary-500 text-base sm:text-sm text-white">2</span>
            <h3 className="text-xl sm:text-lg font-medium text-gray-900 dark:text-white">
              Informations du bien
            </h3>
          </div>
          <PropertyInfo
            formData={formData}
            handleInputChange={handleInputChange}
            handleCopyAddress={handleCopyAddress}
          />
        </div>
      </div>

      {/* Section informations de vente en pleine largeur */}
      <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-t border-gray-200 dark:border-gray-700">
        <div className="flex items-center gap-2 mb-6">
          <span className="flex h-8 w-8 sm:h-6 sm:w-6 items-center justify-center rounded-full bg-primary-500 text-base sm:text-sm text-white">3</span>
          <h3 className="text-xl sm:text-lg font-medium text-gray-900 dark:text-white">
            Informations de prix
          </h3>
        </div>
        <PricingInfo formData={formData} handleInputChange={handleInputChange} />
      </div>

      <div className="mt-6 sm:mt-8 flex justify-end">
        <Button onClick={handleNext}>
          Suivant
        </Button>
      </div>
    </div>
  );
};